module.exports = __webpack_public_path__ + "img/wont_take_vaccine.9f7fcfe2.svg";